import {
  PURSETYPE_LIST_REQUEST,
  PURSETYPE_LIST_SUCCESS,
  PURSETYPE_LIST_FAILURE
} from '../../actions/purseTypeActions'

export default function reducer(
  state = {
    isFetching: false,
    data: {},
    errors: {},
    filters: {
      manual: true
    },
    needRefresh: false
  },
  action
) {
  switch (action.type) {
    case PURSETYPE_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        needRefresh: false
      })

    case PURSETYPE_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.data
      })

    case PURSETYPE_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errors: action.data
      })

    default:
      return state
  }
}
